import styled from 'styled-components';

import { Anchor } from '@ovpn-ui/core';
import { colors } from '@ovpn-ui/styles';

import { TextOverflow as DefaultTextOverflow } from '../TextOverflow';

export const StyledAnchor = styled(Anchor)`
    display: inline-flex;
    max-width: 100%;
    overflow: hidden;

    color: ${colors.primaryBase};
`;

export const TextOverflow = styled(DefaultTextOverflow)<{ $textDecoration?: string }>`
    && {
        text-decoration: ${props => props.$textDecoration || 'initial'} !important;
    }
`;
